<template>
  <div class="login">
    <!-- 左侧：品牌 / 充电桩视觉 -->
    <div class="login-hero">
      <div class="hero-bg">
        <span class="orb orb-1"></span>
        <span class="orb orb-2"></span>
        <span class="orb orb-3"></span>
        <span class="grid"></span>
      </div>

      <div class="hero-content">
        <div class="brand">
          <svg class="brand-bolt" viewBox="0 0 24 24" width="22" height="22">
            <path d="M13 2 L4 14 H11 L9 22 L20 9 H13 Z" fill="#00ffa3"
              style="filter: drop-shadow(0 0 6px #00ffa3)" />
          </svg>
          <span class="brand-name">蔚动力</span>
          <span class="brand-en">WNPOWER</span>
        </div>

        <!-- 充电桩插画 -->
        <div class="hero-pile">
          <svg viewBox="0 0 220 380" width="190" height="320" class="pile-svg">
            <defs>
              <linearGradient id="bodyGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0" stop-color="#163b50" />
                <stop offset="1" stop-color="#0a2230" />
              </linearGradient>
              <linearGradient id="screenGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0" stop-color="#06202c" />
                <stop offset="1" stop-color="#031019" />
              </linearGradient>
              <filter id="glow" x="-60%" y="-60%" width="220%" height="220%">
                <feGaussianBlur stdDeviation="4" result="b" />
                <feMerge>
                  <feMergeNode in="b" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            <!-- 桩体 -->
            <rect x="55" y="24" width="110" height="320" rx="24" fill="url(#bodyGrad)"
              stroke="#1d5b73" stroke-width="1.5" />
            <!-- 顶部灯带 -->
            <rect x="55" y="24" width="110" height="12" rx="6" fill="#00e5ff"
              style="filter: drop-shadow(0 0 6px #00e5ff)" />
            <!-- 屏幕 -->
            <rect x="72" y="64" width="76" height="120" rx="12" fill="url(#screenGrad)"
              stroke="#114055" stroke-width="1.5" />
            <!-- 闪电 -->
            <path class="bolt" d="M110 84 L88 142 L104 142 L96 168 L128 116 L110 116 Z"
              fill="#00ffa3" filter="url(#glow)" />
            <!-- 充电进度条 -->
            <rect x="72" y="200" width="76" height="8" rx="4" fill="#0e2a38" />
            <rect class="charge" x="72" y="200" width="46" height="8" rx="4" fill="#00e5ff" />
            <!-- 指示灯 -->
            <circle cx="82" cy="226" r="4" fill="#00ffa3" />
            <circle cx="100" cy="226" r="4" fill="#00e5ff" />
            <circle cx="118" cy="226" r="4" fill="#1d5b73" />
            <!-- 充电线缆 + 枪头 -->
            <path d="M165 252 C 205 272, 205 322, 178 342" fill="none" stroke="#1d5b73"
              stroke-width="6" stroke-linecap="round" />
            <rect x="166" y="336" width="22" height="30" rx="5" fill="#163b50"
              stroke="#00ffa3" stroke-width="1.5" />
            <!-- 底座 -->
            <rect x="45" y="344" width="130" height="14" rx="7" fill="#0a2230"
              stroke="#1d5b73" stroke-width="1.2" />
          </svg>
        </div>

        <h1 class="hero-title">蔚动力充电运营平台</h1>
        <p class="hero-sub">智能充电 · 绿色出行 · 能源互联</p>

        <div class="hero-stats">
          <div class="stat">
            <div class="stat-num">1,200<span>+</span></div>
            <div class="stat-label">充电站点</div>
          </div>
          <div class="stat">
            <div class="stat-num">8.6<span>GWh</span></div>
            <div class="stat-label">累计充电</div>
          </div>
          <div class="stat">
            <div class="stat-num">96<span>%</span></div>
            <div class="stat-label">设备在线</div>
          </div>
        </div>
      </div>

      <div class="hero-footer">© 2026 蔚动力 WNPOWER · 智慧能源运营平台</div>
    </div>

    <!-- 右侧：登录卡片 -->
    <div class="login-panel">
      <div class="login-card">
        <div class="card-head">
          <div class="card-avatar">
            <svg viewBox="0 0 24 24" width="26" height="26">
              <path d="M13 2 L4 14 H11 L9 22 L20 9 H13 Z" fill="#04222b" />
            </svg>
            <span class="avatar-ring"></span>
          </div>
          <img class="card-logo" src="../../static/images/wnlogo.png" alt="logo" />
          <h2 class="card-title">欢迎登录</h2>
          <p class="card-desc">请输入账号密码进入运营管理后台</p>
          <span class="card-divider"></span>
        </div>

        <el-form :model="loginForm" ref="loginForm" class="login-form">
          <el-form-item prop="loginName" :rules="[{ required: true, message: '请输入账号' }]">
            <el-input v-model="loginForm.loginName" autocomplete="off" placeholder="请输入用户名">
              <svg slot="prefix" class="field-icon" viewBox="0 0 24 24" width="18" height="18">
                <path fill="currentColor"
                  d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 2c-4.4 0-8 2.7-8 6v1h16v-1c0-3.3-3.6-6-8-6Z" />
              </svg>
            </el-input>
          </el-form-item>

          <el-form-item prop="password" :rules="[{ required: true, message: '请输入密码' }]">
            <el-input type="password" v-model="loginForm.password" autocomplete="off" placeholder="请输入密码">
              <svg slot="prefix" class="field-icon" viewBox="0 0 24 24" width="18" height="18">
                <path fill="currentColor"
                  d="M12 1a5 5 0 0 0-5 5v3H6a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-1V6a5 5 0 0 0-5-5Zm3 8H9V6a3 3 0 0 1 6 0v3Z" />
              </svg>
            </el-input>
          </el-form-item>

          <el-form-item class="remember-row">
            <el-checkbox v-model="loginForm.remember">记住密码</el-checkbox>
          </el-form-item>

          <el-button class="login-btn" :loading="fullscreenLoading" @click="submitForm">登 录 系 统</el-button>
        </el-form>

        <div class="card-tip">建议使用 Chrome 浏览器，获得最佳运营体验</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      fullscreenLoading: false,
      loginForm: {
        loginName: "",
        password: "",
        remember: false,
      },
    };
  },
  beforeMount() {
    const rememberPwd = localStorage.getItem("rememberPwd");
    if (rememberPwd == "true") {
      this.loginForm.remember = true;
      this.loginForm.loginName = localStorage.getItem("loginName");
      this.loginForm.password = localStorage.getItem("password");
    } else {
      this.loginForm.remember = false;
    }
  },
  methods: {
    submitForm() {
      localStorage.setItem("rememberPwd", this.loginForm.remember);
      if (this.loginForm.remember) {
        localStorage.setItem("loginName", this.loginForm.loginName);
        localStorage.setItem("password", this.loginForm.password);
      }
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          this.$store.dispatch("login/login", this.loginForm).finally(() => {
            this.fullscreenLoading = false;
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "./Login.less";
</style>



// WEBPACK FOOTER //
// src/views/login.vue